import { Sustainability } from '..';

var fullpage = require('fullpage.js/dist/fullpage.extensions.min');
export let modalSustain = {};
let currentEle;
let currentEleModal;

modalSustain.init = ()=> {
  modalSustain.modalBtn('js-modal-new');
  modalSustain.closeBtnAction('js-modal-close');
}

modalSustain.modalBtn = (e) => {
  let ele = document.getElementsByClassName(e);
  for(let i = 0; i < ele.length; i++) {
    if(!ele[i]) return;

    ele[i].id = e + i;

    ele[i].addEventListener('click', (e) => {
      modalSustain.modalBtnAction(e);
      fullpage_api.destroy('all');
      document.body.style.overflow = 'hidden';
    });
  }
}

modalSustain.modalBtnAction = (e) => {
  if (!e) return;
  currentEle = e.target.id;
  currentEleModal = "js-modal-body";

  if(!document.getElementById(currentEleModal).classList.contains('is-active')) {
    document.getElementById(currentEleModal).classList.add('is-active');
  } else {
    document.getElementById(currentEleModal).classList.remove('is-active');
  }
}

modalSustain.closeBtnAction = (e) => {
  let ele = document.getElementById(e);
  if(!ele) return;

  ele.addEventListener('click' , () => {
    modalSustain.closeModal('js-modal-body');
    fullpage_api.reBuild();
    fullpage_api.setAllowScrolling(true);
    fullpage_api.setAutoScrolling(true);
    Sustainability.init();
    $('.full-width').css('background-image', `${$('.full-width').data('bg')}`);
  });

  ele.addEventListener('touchstart' , () => {
    modalSustain.closeModal('js-modal-body');
    fullpage_api.reBuild();
    fullpage_api.setAllowScrolling(true);
    fullpage_api.setAutoScrolling(true);
    Sustainability.init();
  });
}

modalSustain.closeModal = (e) => {
  let eleParent = document.getElementsByClassName(e);
  if(!eleParent) return;

  for(let i = 0; i < eleParent.length; i++) {
    if(eleParent[i].classList.contains('is-active')) {
      eleParent[i].classList.remove('is-active');
      document.body.style.overflowY = "visible";
    } else {
      eleParent[i].classList.add('is-active');
      document.body.style.overflowY = "hidden";
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/components/featured/sustainability/modules/modal.js